import { CircularProgress, Box } from '@mui/material';

function LoadingProgress() {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 2,
      paddingBottom: 2,
      minHeight: 300,
    }}
    >
      <CircularProgress />
    </Box>
  );
}

export default LoadingProgress;
